import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { useRecentTimelineInfiniteQuery } from "web_myplann/Api/NotificationCenter/useRecentTimelineInfiniteQuery";
import { useDocumentsFeatureOptional } from "web_myplann/Api/Rights/RightsProvider";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { timelineFilterAtom } from "web_myplann/NotificationCenter/Atoms/timelineFilterAtom";
import { useGroupRecentItems } from "web_myplann/NotificationCenter/Hooks/useGroupRecentItems";
import { isDocumentsOnlyActive } from "web_myplann/NotificationCenter/Utils/isDocumentsOnlyActive";

export const useRecentTimelineGroups = (options?: { enabled?: boolean }) => {
	const { t } = useResource();
	const { recentType, recentDocumentsOnly } = useAtomValue(timelineFilterAtom);
	const hasDocumentsFeature = useDocumentsFeatureOptional();
	const query = useRecentTimelineInfiniteQuery(
		{
			type: recentType,
			documentsOnly: isDocumentsOnlyActive(
				recentDocumentsOnly,
				hasDocumentsFeature,
			),
		},
		options,
	);
	const items = useMemo(
		() => query.data?.pages.flatMap((page) => page.items) ?? [],
		[query.data],
	);
	const groups = useGroupRecentItems(items, t);

	return { query, groups };
};
